import * as React from 'react';
import { Col, Row } from 'react-grid-system';
import { BsArrowsAngleExpand } from 'react-icons/bs';
import styled from 'styled-components';


interface Props {
    data: any
    handleOrderComplete: () => void
}

interface ContInterface{
    view: any
}

export default function ViewOrderPreview(props: Props) {

    const { data } = props

    React.useEffect(() => {
    }, [props]);

    return (
        <Content view={props.data}
            onClick={() => props.handleOrderComplete()}
        >
            <div className="content">
                <Row align='center' className='text-white'>
                    <Col xs={10} style={{ textAlign: 'center' }}>
                        <div className='amount'><p>
                            {data.length} {" "}
                            productos. Total: <span>$500</span></p></div>
                    </Col>
                    <Col xs={2} style={{ textAlign: 'right' }} >
                        <BsArrowsAngleExpand
                            style={{ fontSize: '1.5em' }}
                        />
                    </Col>
                </Row>
            </div>
        </Content>
    )
}


const Content = styled.div<ContInterface>`
    position: fixed;
    bottom: 0;
    left: 0;
    width:100%; 
    z-index: 5;
    padding: 1em;
    padding-bottom: 3em;
    display: ${props => props.view.length > 0 ? 'flex': 'none'} ;
    flex-direction: column;
    justify-content:flex-end;
    align-items:flex-end;
    .content{
        background:White;
        width: 100%;
        padding: 1em;
        border-radius: 12px;
        background: #2c3e50;
        /* display:flex;
        flex-direction: column;
        justify-content:Center;
        align-items:Center;
        border-radius: 12px; */
        border-left: 4px solid #2ecc71;
        border-bottom: 4px solid #2ecc71;
        p{
            margin: 0;
            font-size: 1.1em;
            span {
                font-weight: bold;
                color: #2ecc71;
            }
        }
    }
`